import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from './AuthGate';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * UserMenu — displayed in the top-right corner of the AppBar.
 *
 * Reads authenticated user from AuthGate context (no duplicate /auth/me call).
 * REACT_APP_AUTH_DISABLED=true shows "[Dev Mode]" instead of a real user.
 */
const UserMenu = () => {
  const { user } = useAuth();

  if (process.env.REACT_APP_AUTH_DISABLED === 'true') {
    return (
      <Typography variant="body2" sx={{ color: 'inherit', opacity: 0.7 }}>
        [Dev Mode]
      </Typography>
    );
  }

  const handleLogout = () => {
    window.location.href = `${API_BASE_URL}/auth/logout`;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {user && (
        <Typography variant="body2" sx={{ color: 'inherit', opacity: 0.9 }}>
          {user.username}@{user.realm}
        </Typography>
      )}
      <Button
        color="inherit"
        size="small"
        onClick={handleLogout}
        startIcon={<LogoutIcon />}
        sx={{ textTransform: 'none', opacity: 0.9 }}
      >
        Logout
      </Button>
    </Box>
  );
};

export default UserMenu;
